import { render, staticRenderFns } from "./new-card.vue?vue&type=template&id=855d84fe&scoped=true"
import script from "./new-card.vue?vue&type=script&lang=js"
export * from "./new-card.vue?vue&type=script&lang=js"
import style0 from "./new-card.vue?vue&type=style&index=0&id=855d84fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855d84fe",
  null
  
)

export default component.exports